// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1iNgc","question":"styles_question__2woYd","description":"styles_description__2__7P"};